<template>

<com-item name="game.affinity.dna" :size="size" :loading="loading" :is-empty="!active" :has-more="hasMore" v-on:more="onMore" title="Shared DNA">

	<template v-slot:about>

		<p>Most similar games in {{ your }} universe.</p>

	</template>

	<template v-slot:stats>

		<div class="dna-list">

			<div class="dna-row" v-for="(item, index) in items" :key="index">

				<core-avatar type="game" :id="item.id" class="dna-avatar" />

				<div class="dna-info">

					<div class="dna-name"><core-gamename :game="{id: item.id, name: gameName(item.id)}" /></div>

					<div class="dna-shared">{{ subtext(item) }}</div>

				</div>

				<div class="dna-overlap">

					<div class="dna-overlap-fraction"><span class="dna-overlap-count">{{ item.overlap }}</span><span class="dna-overlap-total">/{{ item.total }}</span></div>

				</div>

			</div>

		</div>

	</template>

</com-item>

</template>

<script>

import comItem from './../common/Item'

export default {

	props: ['fetching', 'your', 'you', 'size'],

	components: {
		'com-item': comItem
	},

	computed: {

		loading: function() { return this.fetching === 'all' },

		data: function() { return this.$store.getters['page/insights/game/affinity'] },

		items: function() {

			return (this.data && this.data.dna) ? this.data.dna : []

		},

		total: function() {

			return (this.data && this.data.dnaTotal) ? this.data.dnaTotal : 0

		},

		hasMore: function() { return this.total > 5 },

		active: function() { return !this.loading && this.items.length }

	},

	methods: {

		gameName: function(id) {

			var g = this.$store.getters['data/games/associated'][id]
			return g ? g.name : ''

		},

		subtext: function(item) {

			var names = item.shared
			if (names.length <= 3) return names.join(', ')
			return names.slice(0, 3).join(', ') + ' +' + (names.length - 3)

		},

		goToGame: function(id) {

			this.$router.push({ name: 'InsightsGame', params: { game: id } })

		},

		onMore: function() {

			this.$pubsub.$emit('panel.open', {
				type: 'insightsGameAffinityDNA',
				id: parseInt(this.$route.params.game) || 0
			})

		}

	}

}

</script>

<style scoped>

.dna-list {
	width: 100%;
}

.dna-row {
	display: flex;
	align-items: center;
	padding: 8px 15px;
	cursor: pointer;
	gap: 10px;
}

.dna-row:nth-child(odd) {
	background-color: rgba(12, 137, 178, 0.05);
}

.dna-row:hover {
	background-color: rgba(72, 129, 187, 0.1);
}

.dna-avatar {
	width: 48px;
	height: 48px;
	flex-shrink: 0;
}

.dna-info {
	flex-grow: 1;
	min-width: 0;
	display: flex;
	flex-direction: column;
	justify-content: center;
}

.dna-name {
	font-size: 16px;
	font-weight: 400;
	color: #333;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
	line-height: 18px;
}

.dna-shared {
	font-size: 12px;
	color: #666;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
	margin-top: 1px;
}

.dna-overlap {
	flex-shrink: 0;
	height: 48px;
	display: flex;
	align-items: center;
	justify-content: flex-end;
}

.dna-overlap-count {
	font-size: 24px;
	font-weight: 400;
	color: #333;
}

.dna-overlap-total {
	font-size: 12px;
	font-weight: 400;
	color: #666;
}

</style>
